<template>
  <div class="body">
    <MomentItemFeed  :listType="listType" v-if="listType"></MomentItemFeed>
  </div>
</template>

<script>
  import MomentItemFeed from "../../ugc_item/MomentItemFeed";

  export default {
    name: "MomentMine",
    components: {
      MomentItemFeed,
    },
    data() {
      return {
        listType: "moment_mine",
      }
    },

    mounted() {
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .body {

  }
</style>
